import { render } from "./Com_Font.vue?vue&type=template&id=7041a9c3"
import script from "./Com_Font.vue?vue&type=script&lang=js"
export * from "./Com_Font.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__